<span (click)="openDialog()" class="hover:cursor-pointer">
  @if (this.unreadCount()) {

    <p-overlaybadge [value]="unreadCount() || null">
        <elcia-icon [iconSize]="'3xl'" [iconType]="'bell'"/>
      </p-overlaybadge>
  } @else {
    <elcia-icon [iconSize]="'3xl'" [iconType]="'bell'"/>
  }
</span>

@if (this.isDialogDisplayed()) {
  <elcia-dialog
    (onAction)="this.deleteAllNotifications()"
    (onClose)="closeDialog()"
    [actionIcon]="'minus'"
    [actionLabel]="'action.mark-as-all-read' | translate"
    [size]="'x-small'"
    [title]="'entity.notifications' |translate"
  >
    <div class="flex flex-col gap-2">

      @if (this.notifications().length) {
        @for (notification of this.notifications(); track notification.id) {
          <elcia-notification-item
            (goToNotification)="goToNotification($event)"
            (onDelete)="this.deleteNotification($event)"
            [notification]="notification"
          />

        }
      } @else {
        <div class="text-center">
          {{ 'notification.no-notification' | translate }}
        </div>
      }
    </div>
  </elcia-dialog>
}
